import UbiForm from './Form';

export default UbiForm;
